var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 19.1046C5.83875 19.1046 0.34875 12.7006 0.11775 12.4276C-0.03925 12.2406 -0.03925 11.9676 0.11775 11.7816C0.34875 11.5086 5.83875 5.10461 11.9998 5.10461C19.1798 5.10461 23.7218 11.5456 23.9107 11.8206C24.0397 12.0066 24.0268 12.2556 23.8818 12.4276C23.6507 12.7006 18.1607 19.1046 11.9998 19.1046ZM1.17175 12.1046C2.36475 13.3946 7.06075 18.1046 11.9998 18.1046C16.9808 18.1046 21.7038 13.3266 22.8538 12.0776C21.8577 10.8076 17.7787 6.10461 11.9998 6.10461C7.05375 6.10461 2.36275 10.8136 1.17175 12.1046Z",
    fill: "#000C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 16.1046C9.79351 16.1046 7.99951 14.3106 7.99951 12.1046C7.99951 9.89861 9.79351 8.10461 11.9995 8.10461C14.2055 8.10461 15.9995 9.89861 15.9995 12.1046C15.9995 14.3106 14.2055 16.1046 11.9995 16.1046Z",
    fill: "#000C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4.10461L-0.00014346 19.9536",
    stroke: "#FCFCFC",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 5.10461L1 19.1046",
    stroke: "#000C36",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInactive);
export default __webpack_public_path__ + "static/media/EyeInactive.9726ebda.svg";
export { ForwardRef as ReactComponent };